import get from 'lodash/get';
import ContentItemWithResolver from "models/ContentItemWithResolver";

export default class Navigator extends ContentItemWithResolver {
	get id() {
		return get(this, 'system.id', '');
	}
}
